import React, {useContext, useEffect} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import {getCommonVisualizerType, IS_QKB_UI} from "../../../../config";
import LookAIPopupDropZone from "./LookAIPopupDropZone";
import LookAIPopupGeneratedImages from "./LookAIPopupGeneratedImages";
import {getLookList} from "../../../look/lookNavigation/lookFunctions";
import LookAiPopupContext from "./LookAiPopupContext";
import LookAIPopupFeatureGroups from "./LookAIPopupFeatureGroups";
import {getCurrentLayout} from "../../../appLayout";


const LookAIPopupContent = (props) => {

  const {setLookOverlayOpened, intl, visualizersLoadedLength, showLeadOverlay, isMobile, aiSettings} = props;

  const {lookAiPopupDispatch} = useContext(LookAiPopupContext);

  const closeAIPopup = () => {
    setLookOverlayOpened("");
  }

  const setInitialAiLogic = () => {
    const lookList = getLookList();
    if (!visualizersLoadedLength || (!lookList && !aiSettings.aiGroups)) {
      return
    }
    const layout = getCurrentLayout();
    const groupsList = aiSettings.aiGroups && aiSettings.aiGroups.length ? aiSettings.aiGroups.map(groupName => {
      const featureGroup = layout.getFeatureGroupByGroupName(groupName);
      if (featureGroup) {
        return {
          featureGroup,
          partId: featureGroup.partId,
        }
      }
    }).filter(groupName => groupName) : lookList;
    lookAiPopupDispatch({
      // userFile: null,
      groupObjects: groupsList
        .filter(groupObject => groupObject.featureGroup && groupObject.featureGroup.activeFeature)
        .map(groupObject => {
          groupObject.enabled = true;
          return groupObject
        }),
    });
  }

  useEffect(() => {
    setInitialAiLogic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visualizersLoadedLength]);

  const visualizerType = getCommonVisualizerType();

  return (
    <div className="look-ai__content w-full p-1 bg-white flex--1 scrollable">
      <div className="flex flex--center flex--between mb-05 mt-05">
        <h2 className={"bold font--16 m-0" + (IS_QKB_UI ? " color-primary" : "")}>
          <FormattedMessage id={"look.ai.panel.title"} values={{visualizerType}}/>
        </h2>
        <IconButton aria-label={intl.formatMessage({id: "iconButton.close"})}
                    className="look-icon look-icon--small"
                    onClick={closeAIPopup}>
          <CloseIcon/>
        </IconButton>
      </div>
      <div className="font--12 leading-1 look-ai__panel-text mb-1">
        <FormattedMessage id={isMobile ? "look.ai.panel.mobile.subTitle" : "look.ai.panel.subTitle"}
                          values={{visualizerType}}/>
      </div>
      <LookAIPopupDropZone/>
      <LookAIPopupGeneratedImages showLeadOverlay={showLeadOverlay}/>
      <LookAIPopupFeatureGroups/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookOverlayOpened} = store.lookState;
  const {visualizersLoaded, isMobile} = store.serverState;
  const {aiSettings} = store.fabricatorState

  return {
    lookOverlayOpened,
    visualizersLoadedLength: visualizersLoaded.length,
    isMobile,
    aiSettings,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookAIPopupContent)
)
